import React, { useEffect, useState } from 'react';
import { a2a, getActor, setActor } from '../../lib/a2aApi';
import { useTranslation } from 'react-i18next';

/** Demo-only: act as a seeded persona so the two-person rule can be shown with one browser session. */
const ActorSwitch: React.FC<{ apiUrl: string; onChange?: () => void }> = ({ apiUrl, onChange }) => {
  const { t } = useTranslation();
  const [demo, setDemo] = useState(false); const [actor, setA] = useState(getActor());
  useEffect(() => { a2a.config(apiUrl).then((c) => setDemo(c.demo)).catch(() => setDemo(false)); }, [apiUrl]);
  if (!demo) return null;
  return (
    <label className="a2a-muted" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      {t('components.a2a.actorSwitch.actingAs')}
      <select value={actor} onChange={(e) => { setActor(e.target.value); setA(e.target.value); onChange?.(); }} style={{ padding: '4px 6px' }}>
        <option value="">{t('components.a2a.actorSwitch.meSignedIn')}</option><option value="director">{t('components.a2a.actorSwitch.director')}</option><option value="approver">{t('components.a2a.actorSwitch.approver')}</option>
      </select>
    </label>
  );
};
export default ActorSwitch;
